import { Component, Input, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { Apresentacao, Demands } from '../../models/apresentacao.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ApresentacaoService } from '../../services/apresentacao.service';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-apresentacao-demandas',
  templateUrl: './apresentacao-demandas.component.html',
  styleUrls: ['./apresentacao-demandas.component.scss']
})
export class ApresentacaoDemandasComponent extends BaseFormComponent<Demands>   implements OnInit {

  //exemplo em 762
  id:number;
  data: Demands = null;
  @Input() print:boolean = false;

  constructor(
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public myService: ApresentacaoService,
    private apresentacaoResolverId: ApresentacaoResolverId,
    private sanitizer: DomSanitizer
  ) { 
    super(activatedRoute); 
  }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }

  start(){
    this.myService.getDemandsData(this.id ).subscribe({
      next: (res:Demands) => {
        this.entity = res;
        this.data = res;
        this.loaded();
      },
      error: (error) => {
        this.loaded();
        this.msgError();
      },
    })
  }

}
